export enum BannerUpsellColor {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum BannerUpsellSize {
  SMALL = 'small',
  LARGE = 'large',
  LARGE_WITH_IMAGE = 'large-with-image',
  XLARGE = 'xlarge',
}
